import React, { useEffect, useState } from 'react'
import Rating from '@mui/material/Rating';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Post from './Post';
import { db } from '../../../../firebase';

function Comments({ branchId}) {
  const [posts, setPosts] = useState([])
  useEffect(() => {
    db.collection('branches').doc(branchId).collection("reviews").orderBy("ratingTime", "desc").onSnapshot(snapshot => {
        setPosts(snapshot.docs.map(doc => ({
            id: doc.id,
            post: doc.data(),
        })));
    })
}, []);

  return (
    <div>
     {
                                     posts.map(({id, post}) => (
                                      <Post
                                      key={id} 
                                      ratedByUid={post?.ratedByUid}
                                      rating={post?.rating}
                                      ratingComment={post?.ratingComment}
                                      ratingTime={post?.ratingTime}
                                      menuId={post?.menuId}
                                      branchId={post?.branchId}
                                      reviewId = {id}
                                      />
                                     ) )
     }
    </div>
  )
}

export default Comments